import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { AuthenticationService } from 'src/app/components/pages/authentication/authentication/authentication.service';
import { MeasurementResponse, ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ScaleNote } from 'src/app/models/scale-note';
import { VendorResponse } from 'src/app/models/vendor.model';
import { ExitNoteService } from 'src/app/services/exit-note.service';
import { ProductService } from 'src/app/services/product.service';
import { ScaleNoteService } from 'src/app/services/scale-note.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-create-exit-note',
  templateUrl: './create-exit-note.component.html',
  styleUrls: ['./create-exit-note.component.scss']
})
export class CreateExitNoteComponent {
  @Output() closed = new EventEmitter<boolean>();
    @Input() showModal: boolean = false;
    loading = false;
    exitNote = {};
    products: ProductResponse[] = [];
    providers: VendorResponse[] = [];
    clients: VendorResponse[] = [];
    scales: ScaleNote[] = []
    date = new Date();
    detailList = [];
    total = 0;
    inputs = {
      provider: {
        value: null,
        verified: false,
        required: true,
        message: 'Campo requerido',
        class: "fa-list",
        color: '',
        tooltip: '',
        data: {
          id: null
        }
      },
      product: {
        value: null,
        verified: false,
        required: false,
        message: 'Campo requerido',
        class: "fa-list",
        color: '',
        tooltip: '',
        data: {
          id: null,
          measurement: null
        }
      },
      scales: {
        value: null,
        verified: false,
        required: true,
        message: 'Campo requerido',
        class: "fa-list",
        color: '',
        tooltip: '',
        data: {
          id: null
        }
      },
    };
    exitNoteData = {
      providerId: null,
      exitDate: '',
      transactionDescription: '',
      // scaleTicketNumber: '',
      pilotName: '',
      headLicensePlate: '',
      tanketLicensePlate: '',
    };
    quantity = 0;
    quantityDispatched = 0;
    filterProviders: VendorResponse[] = [];
    filterClients: VendorResponse[] = [];
    filterProducts: ProductResponse[] = [];
    filterScales: any[] = [];
    timeout = null;
    currentClient: VendorResponse;
    currentProvider: VendorResponse;
    productList = [];
  
    constructor(
      private exitNoteService: ExitNoteService,
      private vendorService: VendorService,
      private productService: ProductService,
      private toastService: ToastrService,
      private authService: AuthenticationService,
      private scaleNoteService: ScaleNoteService
    ) {
      // var getUserPosition = authService.getUserPosition();
      // if (getUserPosition) {
      //   getUserPosition.forEach((u) => {
      //     if (u.warehouse != 0) {
      //       this.allowedWarehouses[u.warehouse] = true;
      //     }
      //   });
      // }
    }
  
    ngOnInit(): void {
      this.getInitialData();
    }
  
    getInitialData() {
      this.getProviders("");
      this.getProducts("");
      // this.getClients("");
      this.getScales("");
    }
  
    getProviders(clue) {
      this.vendorService.getProvidesByClue(clue).subscribe({
        next: (response: ResponseObject) => {
          this.providers = response.data;
          this.filterProviders = this.providers;
          if (this.filterProviders.length == 0) {
            this.changeInput(this.inputs.provider, null, false, null, 'fa-xmark', null);
          } else if (this.filterProviders.length == 1) {
            this.changeInput(this.inputs.provider, this.filterProviders[0].name, true, null, 'fa-circle-check', this.filterProviders[0]);
          } else {
            if (clue == "") {
              this.changeInput(this.inputs.provider, clue, false, null, 'fa-asterisk', null);
            } else {
              this.changeInput(this.inputs.provider, clue, false, null, 'fa-list', null);
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      });
    }
  
    getProducts(clue) {
      this.productService.getProducts(clue).subscribe({
        next: (response: ResponseObject) => {
          this.products = response.data
  
          this.filterProducts = this.products;
          if (this.filterProducts.length == 0) {
            this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
          } else if (this.filterProducts.length == 1) {
            this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
          } else {
            this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
          this.toastService.error(error.error.message);
        }
      });
    }
  
    getScales(clue) {
      this.scaleNoteService.getScalesNoteAll().subscribe({
        next: (response: ResponseObject) => {
          this.scales = response.data
          this.filterScales = this.scales;

          if (this.filterScales.length == 0) {
            this.changeInput(this.inputs.scales, null, false, null, 'fa-xmark', null);
          } else if (this.filterScales.length == 1) {
            this.changeInput(this.inputs.scales, this.filterScales[0].name, true, null, 'fa-circle-check', this.filterScales[0]);
          } else {
            this.changeInput(this.inputs.scales, clue, false, null, 'fa-list', null);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.changeInput(this.inputs.scales, null, false, null, 'fa-xmark', null);
          this.toastService.error(error.error.message);
        }
      });
    }
  
    changeInput(input, value, verified, required, classIcon, data) {
      input.value = (value) ? value : input.value;
      input.verified = (verified) ? verified : input.verified;
      input.required = (required) ? required : input.required;
      input.class = (classIcon) ? classIcon : input.class;
      input.data = (data) ? data : input.data;
    }
  
    writeProvider(input) {
      var inputValue = input.target.value;
      clearTimeout(this.timeout);
      this.inputs.provider.class = "typing";
      this.timeout = setTimeout(() => {
        this.getProviders(inputValue);
      }, 500);
    }
  
    checkProvider(vendor: VendorResponse) {
      this.inputs.provider.class = "fa-circle-check";
      this.inputs.provider.verified = true;
      this.inputs.provider.data = vendor;
      this.inputs.provider.value = vendor.name;
      this.currentProvider = vendor;
    }
  
    writeProduct(input) {
      var inputValue = input.target.value;
      clearTimeout(this.timeout);
      this.inputs.product.class = "typing";
      this.timeout = setTimeout(() => {
        this.getProducts(inputValue);
      }, 500);
    }
  
    checkProduct(product: ProductResponse) {
      this.inputs.product.class = "fa-circle-check";
      this.inputs.product.verified = true;
      this.inputs.product.data = product;
      this.inputs.product.value = product.name;
    }
  
    writeScale(input) {
      var inputValue = input.target.value;
      clearTimeout(this.timeout);
      this.inputs.scales.class = "typing";
      this.timeout = setTimeout(() => {
        // this.getWarehouses(inputValue);
      }, 500);
    }
  
    checkScale(note: ScaleNote) {
      this.inputs.scales.class = "fa-circle-check";
      this.inputs.scales.verified = true;
      this.inputs.scales.data = note;
      this.inputs.scales.value = note.noteNumber;
    }
  
    addProduct() {
      let measureId = this.inputs.product.data.measurement;
  
      this.productService.getMeasurementsByMeasurementId(measureId).subscribe({
        next: (response: ResponseObject) => {
          let measurements: MeasurementResponse = response.data;
          this.productList.push({
            productData: this.inputs.product.data,
            quantity: this.quantity,
            quantityDispatched: this.quantityDispatched,
            itemId: measurements.id,
            item: measurements.unit
          });
          this.inputs.product.value = "";
          this.quantity = 0;
          this.quantityDispatched = 0;
          this.getProducts('');
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      });
      
      // this.productList.push({ 
      //   productData: this.inputs.product.data, 
      //   quantity: this.quantity, quantityReceived: 
      //   this.quantityReceived, 
      //   itemId: this.inputs.product.data.measurement, 
      //   item: "" });
      // this.inputs.product.value = "";
      // this.quantity = 0;
      // this.getProducts('');
    }
  
    createNote() {
      if (!this.inputs.provider.verified) {
        this.toastService.error("Debe seleccionar un proveedor válido", "Error");
        return;
      }
      if (!this.inputs.scales.verified) {
        this.toastService.error("Debe seleccionar una boleta válido", "Error");
        return;
      }
      if (this.productList.length == 0) {
        this.toastService.error("Debe agregar al menos un producto a la nota de entrada", "Error");
        return;
      }
      if (!this.verifyCreateNoteData()) {
        this.toastService.error("Debe completar todos los campos requeridos", "Error");
        return;
      }
  
      this.loading = true;
      let request = {
        ...this.exitNoteData,
        providerId: this.inputs.provider.data.id,
        scaleTicketNumber: this.inputs.scales.data.id,
        details: this.productList.map((p) => {
          return {
            productId: p.productData.id,
            quantity: p.quantity,
            quantityDispatched: p.quantityDispatched,
          }
        }
        )
      };
      
      this.exitNoteService.createExitNote(request).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Nota de entrada creada con éxito", "Éxito");
          this.loading = false;
          this.closed.emit(true);
          this.showModal = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message, "Error");
        }
      });
    }
  
    verifyCreateNoteData() {
      if (this.exitNoteData.exitDate == '' ||
        // this.exitNoteData.providerId == null ||
        this.exitNoteData.transactionDescription == '' ||
        // this.exitNoteData.scaleTicketNumber == '' ||
        this.exitNoteData.pilotName == '' ||
        this.exitNoteData.headLicensePlate == '' ||
        this.exitNoteData.tanketLicensePlate == '') {
        return false;
      }
      return true;
    }
  
    removeProduct(index: number) {
      this.productList.splice(index, 1);
    }
  
    closeModal(modal: ModalDialogComponent) {
      modal.onClose();
      this.closed.emit(false);
    }
  
    closedCreateNote() {
      this.closed.emit(false);
      this.showModal = false;
    }
}
